import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';
import { Helmet } from 'react-helmet';
import Icon from './common/icons/Icon';
import AffiliateSignUpForm from './AffiliateSignUpForm';
import { createAffiliate } from './redux/actions';
import { formatValidationErrors } from './common/utils/getApiReducer';
import { reportAffiliateSignup } from './common/events';

class AffiliateSignUp extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    const initialState = {
      success: false,
      defaultFirstName: '',
      defaultLastName: '',
      defaultEmail: '',
    };

    if (props.user.get('data')) {
      const user = this.props.user.get('data').toJS();

      const splitName = user.name.split(' ');

      if (splitName.length > 1) {
        initialState.defaultFirstName = splitName[0];
        initialState.defaultLastName = splitName[splitName.length - 1];
      }

      initialState.defaultEmail = user.oidc_user.email;
    }

    this.state = initialState;
  }

  handleSubmitAffiliateSignUpForm = values => {
    return this.props.dispatch(createAffiliate(values)).then(action => {
      if (!action.response.ok) {
        if (action.json.validationErrors) {
          throw new SubmissionError(formatValidationErrors(action.json).toJS());
        } else {
          throw new SubmissionError(
            action.json && action.json.message ? { _error: action.json.message } : 'An unknown error occurred.'
          );
        }
      } else {
        this.setState({ success: true });
        reportAffiliateSignup();
      }
    });
  };

  render() {
    const title = (
      <Helmet>
        <title>Tathata Golf - Affiliate Sign Up</title>
      </Helmet>
    );
    if (this.state.success) {
      return (
        <div className="subscribe__wrapper">
          {title}
          <div className="subscribe__centered">
            <h3>Thank you for signing up!</h3>
            <p className="text--muted">
              Thank you for becoming a Tathata Golf Affiliate! Please check your email for confirmation and next steps.
            </p>
          </div>
        </div>
      );
    }

    const { defaultFirstName, defaultLastName, defaultEmail } = this.state;

    return (
      <div className="subscribe__wrapper">
        {title}
        <div className="container">
          <div className="subscribe">
            <div className="subscribe__details">
              <div>
                <h3>Become a Tathata Affiliate</h3>
                <p>
                  You, or your organization, will be up and running as a Tathata Golf affiliate after filling out the
                  information on this page. You can begin to enjoy the financial and indirect benefits of your users
                  purchasing our training membership, improving their game and playing more golf. If you have any
                  questions, please don’t hesitate to contact us at{' '}
                  <a href="mailto:affiliates@tathatagolf.com">affiliates@tathatagolf.com</a>.
                </p>
              </div>
              <div>
                <ul>
                  <li>
                    <Icon icon="CheckmarkCircle" />Take advantage of our global marketing efforts
                  </li>
                  <li>
                    <Icon icon="CheckmarkCircle" />Earn thousands per month, no cap!
                  </li>
                  <li>
                    <Icon icon="CheckmarkCircle" />Utilize Tathata Golf's plug-n-play marketing assets
                  </li>
                  <li>
                    <Icon icon="CheckmarkCircle" />Simple link & promo code options
                  </li>
                </ul>
              </div>
            </div>
            <AffiliateSignUpForm
              onSubmit={this.handleSubmitAffiliateSignUpForm}
              initialValues={{
                firstName: defaultFirstName,
                lastName: defaultLastName,
                email: defaultEmail,
                usTaxable: 'true',
                coupon: '',
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  user: state.subscription.user,
}))(AffiliateSignUp);



// WEBPACK FOOTER //
// ./src/AffiliateSignUp.js